// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 4C7.58867 4 4 7.6046 4 12.0667V13H5.99979C7.65665 13 9 14.3431 9 16V18C9 19.6569 7.65685 21 6 21H2V12.0667C2 6.51397 6.47021 2 12 2C17.5298 2 22 6.51397 22 12.0667V21H18C16.3431 21 15 19.6569 15 18V16C15 14.3431 16.3431 13 18 13H20V12.0667C20 7.6046 16.4113 4 12 4Z"}}]};

const EarphoneFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'earphone-filled',
    ref,
    icon: element,
  },
));

EarphoneFilledIcon.displayName = 'EarphoneFilledIcon';

export default EarphoneFilledIcon;
